exports.verifyPermission = (given_controller, given_action) => {

  let menuList = JSON.parse(localStorage.getItem('menu_list'));
  let flag = false;

  menuList.forEach(menu => {

    if(menu.controller.controller_name == given_controller) {

      menu.controller.actions.forEach(action => {
        if(action.action_name == given_action) {
          flag = true;
          return flag;
        }
      })
    }
  });

  return flag;
};